import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@common-fe/common-fe';

import { StepperSidebar } from '@/components';
import { Topbar } from '@/modules/core/components';
import theme from '@/styles/theme';

interface Props {
  children?: React.ReactNode;
  currentStep: number;
  isSwitchMode?: boolean;
  isEmptyPortfolioMode?: boolean;
}
const ManagedWrapper: React.FC<Props> = ({ children, currentStep, isEmptyPortfolioMode, isSwitchMode }) => {
  const { t } = useTranslation();
  const OPTIONS = useMemo(() => {
    if (isSwitchMode) {
      if (isEmptyPortfolioMode) {
        return [
          { key: 1, value: t('Portfolio Questionnaire') },
          { key: 2, value: t('Initial Funding Amount') },
          { key: 3, value: t('Portfolio Allocation') },
        ];
      }
      return [
        { key: 1, value: t('Portfolio Questionnaire') },
        { key: 2, value: t('Portfolio Allocation') },
      ];
    }

    return [
      { key: 1, value: t('Portfolio Questionnaire') },
      { key: 2, value: t('Initial Funding Amount') },
      { key: 3, value: t('Portfolio Allocation') },
    ];
  }, [isEmptyPortfolioMode, isSwitchMode, t]);
  return (
    <Box direction="column">
      <div>
        <Box direction="row" flex="grow" fill data-testid="StartInvesting-wrapper">
          <StepperSidebar
            title={isSwitchMode ? t('Investments Model Switch') : t('Start Investing')}
            options={OPTIONS}
            step={currentStep}
          />
          <Box
            direction="row"
            justify="center"
            flex="grow"
            overflow={{ vertical: 'auto' }}
            height={{
              min: '100vh',
            }}
            style={{
              display: 'block',
              position: 'relative',
            }}
          >
            <Box direction="row" justify="center">
              <Box flex="grow" pad={{ horizontal: '40px' }} margin={{ bottom: 'l' }}>
                <Topbar />
              </Box>
            </Box>

            <Box
              direction="column"
              width={{ max: theme.defaultContentWidth }}
              margin={{ horizontal: 'xl' }}
              pad={{ horizontal: 'xs' }}
              style={{ position: 'relative', margin: '0 auto' }}
            >
              <div>{children}</div>
            </Box>
          </Box>
        </Box>
      </div>
    </Box>
  );
};
export default ManagedWrapper;
